const events = document.querySelectorAll(".event-listing-container");
const months = document.querySelectorAll("[data-month]");
const placeFilter = document.querySelector("#place");

if (placeFilter) {
  placeFilter.addEventListener("change", function () {
    const selectedPlace = this.value;
    let monthsWithEvents = [];
    events.forEach(function (element) {
      if (selectedPlace === "") {
        element.classList.remove("hidden");
      } else if (element.getAttribute("data-place") !== selectedPlace) {
        element.classList.add("hidden");
      } else {
        element.classList.remove("hidden");
        monthsWithEvents.push(element.getAttribute("data-eventMonth"));
      }
    });

    months.forEach(function (element) {
      const thisMonth = element.getAttribute("data-month");
      if (selectedPlace === "") {
        element.classList.remove("hidden");
      } else if (!monthsWithEvents.includes(thisMonth)) {
        element.classList.add("hidden");
      } else {
        element.classList.remove("hidden");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (placeFilter !== null) {
    placeFilter.value = "";
  }
});
